import { render, staticRenderFns } from "./brandBuilding.vue?vue&type=template&id=7a0a1927&scoped=true&"
import script from "./brandBuilding.vue?vue&type=script&lang=js&"
export * from "./brandBuilding.vue?vue&type=script&lang=js&"
import style0 from "./brandBuilding.vue?vue&type=style&index=0&id=7a0a1927&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a1927",
  null
  
)

export default component.exports